import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { getAccountApprovalByAccountApprovalTypeIdAsync,updateAccountApprovalTypeAsync, deleteAccountApprovalTypeAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateSorting } from "./AccountApprovalSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { getValueFromResource} from "../../../common/timeLiveFunction";

const itemClass = 'ms-1 ms-lg-0';


export const AccountApprovalItem = (props: any) => {

     const { accountApprovalList,t, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();
    const {  isReload,selectedRecord, sortOrder,sortColumn, pageSize  } = useAppSelector((state) => state.accountApproval)
    const { manageTerminologyList } = useAppSelector((state) => state.globalState);

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountApprovalTypeId: number) => {
        dispatch(getAccountApprovalByAccountApprovalTypeIdAsync(AccountApprovalTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('getExternalUserByExternalUserIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    const onDeleteClick = (AccountApprovalTypeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountApprovalTypeAsync(AccountApprovalTypeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("Account approval deleted Successfully", 'Success', "success", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            console.log('onDeleteClick-deleteExternalUserAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }


    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsTimeOffApprovalTypes = (e: any, AccountApprovalType: any) => {
        const { checked } = e.target;
        const foundIndex = accountApprovalList.findIndex((item: any) => item.AccountApprovalTypeId === AccountApprovalType.AccountApprovalTypeId);
        if (foundIndex !== -1) {
            const foundItem = accountApprovalList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsTimeOffApprovalTypes = checked;
            const modifiedList = [...accountApprovalList.slice(0, foundIndex), updatedItem, ...accountApprovalList.slice(foundIndex + 1)];
            dispatch(updateAccountApprovalTypeAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Account Approval Updated Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }


    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
        
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >

                    <th style={{width:'75%'}}>
                        {/* {t('Approval Type Name')} */}
                        {getValueFromResource('Approval Type Name',dispatch, t)}

                        {sortColumn === 'ApprovalTypeName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ApprovalTypeName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ApprovalTypeName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ApprovalTypeName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ApprovalTypeName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th style={{width:'15%', textAlign:'center'}}>
                            {/* {t('Time Off Approval')} */}
                                {getValueFromResource('Time Off Approval',dispatch, t)}

                        {sortColumn === 'IsTimeOffApprovalTypes' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsTimeOffApprovalTypes") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsTimeOffApprovalTypes") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsTimeOffApprovalTypes") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsTimeOffApprovalTypes") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {accountApprovalList.length > 0 && accountApprovalList.map((accountApprovalTypeDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <a id={`${IsEdit ? 'kt_OffCanvas' : ''}`}
                                    className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                    style={{ cursor: 'pointer' }}
                                     onClick={IsEdit ? () => onEditClick(accountApprovalTypeDetail.AccountApprovalTypeId) : undefined}>                                   
                                    {accountApprovalTypeDetail.ApprovalTypeName}
                                </a>
                            </td>
                            
                           
                         
                                <td className='text-center'>
                                     <span >{accountApprovalTypeDetail.IsTimeOffApprovalTypes ? 'Yes' : 'No'}</span>
                                  
                                </td>
                          
                                <td className='text-center' >
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}

                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                    {IsEdit &&
                                                        <>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item  id="kt_OffCanvas"
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => {
                                                                        dispatch(getAccountApprovalByAccountApprovalTypeIdAsync(accountApprovalTypeDetail.AccountApprovalTypeId))
                                                                            .unwrap()
                                                                            .then((originalPromiseResult) => {
                                                                             
                                                                            })
                                                                            .catch((rejectedValueOrSerializedError) => {
                                                                            })
                                                                    }}
                                                                >
                                                                    <span className="menu-icon custom-menu">
                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Edit')}`} */}
                                                                        {getValueFromResource('Edit',dispatch, t)}

                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                    {IsDelete && IsEdit && (accountApprovalTypeDetail.MasterAccountApprovalTypeId === null || accountApprovalTypeDetail.MasterAccountApprovalTypeId === 0) &&
                                                        <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                    }
                                                    {/* {IsDelete && */}
                                                    {IsDelete === true && (accountApprovalTypeDetail.MasterAccountApprovalTypeId === null || accountApprovalTypeDetail.MasterAccountApprovalTypeId === 0) &&
                                                        <>
                                                            <div className='menu-hover-bg-danger'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onDeleteClick(accountApprovalTypeDetail.AccountApprovalTypeId) }}>
                                                                    <span className="menu-icon  custom-menu">
                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                        {/* {`${t('Delete')}`} */}
                                                                        {getValueFromResource('Delete',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
                              {accountApprovalList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }
  
        </>
    )


    
}